import axios from "@/axios"

const url = "/api/brain/specimens/locations"

class SpecimenLocationService {
	async getLocations(params) {
		try {
			const { data } = await axios.get(`${url}`, { params })
			return data
		} catch (error) {
			throw error
		}
	}

	async storeLocations(params) {
		try {
			const { data } = await axios.post(`${url}`, params)
			return data
		} catch (error) {
			return error.response
		}
	}

	async switchActive(id) {
		try {
			const { data } = await axios.put(`${url}/switch-active/${id}`)
			return data
		} catch (error) {
			return error.response
		}
	}
	async saveSpecimenLocation(params) {
		try {
			const { data } = await axios.post(`${url}/save-specimen-location`, params)
			return data
		} catch (error) {
			return error.response
		}
	}
	async getSpecimenTracking(id) {
		try {
			const { data } = await axios.get(`${url}/specimen-tracking/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}
	async getLocationTracking(id) {
		try {
			const { data } = await axios.get(`${url}/location-tracking/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async getLocationDetails(params) {
		try {
			const { data } = await axios.get(`${url}/details`, { params })
			return data
		} catch (error) {
			throw error
		}
	}

	async releaseSpecimens(params) {
		try {
			await axios.post(`${url}/release`, params)
		} catch (error) {
			throw error
		}
	}

	async searchFreeSpecimen(params) {
		try {
			const { data } = await axios.get(`${url}/search-free-specimen`, { params })
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new SpecimenLocationService()
